import { TabButton, TabItem } from '@ui/Tabs';
import { ReactNode, useState } from 'react';

type UseTabsProps = {
  full?: boolean;
  tabItems: TabItem[];
  initial?: number;
  onTabChange?: (index: number) => void;
};

export function useTabs({
  tabItems,
  full,
  initial,
  onTabChange,
}: UseTabsProps): {
  currentBody: ReactNode;
  tabs: ReactNode;
  setCurrent: (index: number) => void;
} {
  const [current, setCurrent] = useState(initial ?? 0);

  const handleTabChange = (index: number) => {
    setCurrent(index);
    onTabChange?.(index);
  };

  const currentBody = tabItems[current]?.contents;
  const tabs: ReactNode = (() => {
    return (
      <div
        className={`flex gap-x-6 p-4 w-${
          full ? 'full' : 'min'
        } overflow-x-auto overflow-y-hidden`}
      >
        {tabItems.map((item, i) => {
          const isCurrent = current === i;

          return (
            <TabButton
              key={item.title}
              title={item.title}
              onClick={() => handleTabChange(i)}
              isCurrent={isCurrent}
              unreads={item.unreads}
            />
          );
        })}
      </div>
    );
  })();

  return { currentBody, tabs, setCurrent: handleTabChange };
}
